import LookupAttributesRequestModelBase from '../_generated/modelBases/lookup-attributes-request-model-base';

export default class LookupAttributesRequestModel extends LookupAttributesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
